const dictionary = {
    ACTIVATE_POLYGON: 'Activate Polygon',
    ACTIVE: 'Active',
    ACTIVE_CUSTOMERS: 'Active Customers',
    ADD_POLYGON: 'Add Polygon',
    ALL_AREAS: 'All Areas',
    AREA_ID: 'Area ID',
    AREA_NAME: 'Area Name',
    ASSIGNED_POLYGONS: 'Assigned Polygons',
    CANCEL: 'Cancel',
    CLEAR_OUTCOMES: 'Clear Outcomes',
    CLEAR_OUTCOMES_CONFIRMATION_TITLE: {
        SINGULAR: 'Are you sure you want to clear all the outcomes in this polygon?',
        PLURAL: 'Are you sure you want to clear all the outcomes in these polygons?',
    },
    CLEAR_OUTCOMES_CONFIRMATION_MESSAGE: {
        SINGULAR: 'Clearing the outcomes will remove any information that is associated with it.',
        PLURAL: 'Clearing the outcomes will remove any information that is associated with them.',
    },
    CLEAR_OUTCOMES_CONFIRMATION_CONFIRM: 'Clear Outcomes',
    COLLAPSE: 'Collapse',
    COLLAPSE_ALL: 'Collapse All',
    CREATE_POLYGON: 'Create Polygon',
    CURRENT_PINS: 'Current Pins',
    DEACTIVATE_POLYGON: {
        SINGULAR: 'Deactivate Polygon',
        PLURAL: 'Deactivate Polygons',
    },
    DEACTIVATE_POLYGON_CONFIRMATION_TITLE: {
        SINGULAR: 'Are you sure you want to deactivate this polygon?',
        PLURAL: 'Are you sure you want to deactivate these polygons?',
    },
    DEACTIVATE_POLYGON_CONFIRMATION_MESSAGE: {
        SINGULAR: 'Deactivating the polygon will remove any reps that are associated with it.',
        PLURAL: 'Deactivating polygons will remove any reps that are associated with them.',
    },
    DEACTIVATE_POLYGON_CONFIRMATION_CONFIRM: {
        SINGULAR: 'Deactivate Polygon',
        PLURAL: 'Deactivate Polygons',
    },
    DELETE_POLYGON: {
        SINGULAR: 'Delete Polygon',
        PLURAL: 'Delete Polygons',
    },
    DELETE_POLYGON_CONFIRMATION_TITLE: {
        SINGULAR: 'Are you sure you want to delete this polygon?',
        PLURAL: 'Are you sure you want to delete these polygons?',
    },
    DELETE_POLYGON_CONFIRMATION_MESSAGE: {
        SINGULAR: 'Deleting the polygon will remove any information that is associated with it.',
        PLURAL: 'Deleting polygons will remove any information that is associated with them.',
    },
    DELETE_POLYGON_CONFIRMATION_CONFIRM: {
        SINGULAR: 'Delete Polygon',
        PLURAL: 'Delete Polygons',
    },
    DISPLAY_OUTCOMES: 'Display outcomes',
    DO_NOT_KNOCK_ADMIN: 'Do Not Knock (Admin Added)',
    DO_NOT_KNOCK_REP: 'Do Not Knock (Rep Added)',
    EXPAND: 'Expand',
    EXPAND_ALL: 'Expand All',
    FILTER: 'Filter',
    FILTER_BY_AREAS: 'Filter by areas',
    FIRST_KNOCK: '1st Knock',
    GOOGLE_HYBRID: 'Google Hybrid',
    GOOGLE_MAPS: 'Google Maps',
    GOOGLE_SATELLITE: 'Google Satellite',
    HIDE_PINS: 'Hide Pins',
    ICONS: 'Icons',
    ID: 'ID',
    INACTIVE: 'Inactive',
    INACTIVE_CUSTOMERS: 'Inactive Customers',
    LEADER: 'Leader',
    NEW_MOVER: 'New Mover',
    NONE: 'None',
    NOT_KNOCKED: 'Not Knocked',
    NUMBER_OF_REPS: '# Reps',
    OPEN_STREET_MAP: 'OpenStreetMap',
    PERCENTAGE: 'Percentage',
    PIN_SCORE: 'PIN Score',
    PINS: 'Pins',
    POLYGONS: 'Polygons',
    PREVIOUS_CUSTOMER: 'Previous Customer',
    PROGRESS: 'Progress',
    QUALIFIED_ADDRESSES: 'Qualified Addresses',
    QUALIFIED_PERCENTAGE: 'Qualified Percentage',
    RECENT_REFINANCED: 'Recent Refinanced',
    REMOVE_ALL_REPS: 'Remove All Reps',
    REPS: 'Reps',
    SEARCH_AREAS: 'Search Areas',
    SEARCH_TEAMS: 'Search Teams',
    SECOND_KNOCK: '2nd Knock',
    SELECTED_POLYGON_INFORMATION: {
        SINGULAR: 'Selected Polygon Information',
        PLURAL: 'Selected Polygons Information',
    },
    SELECT_ALL: 'Select All',
    SELECT_MULTIPLE_POLYGONS_TIP: 'Tip: Hold Cmd or Ctrl and then click to select multiple polygons',
    SUBMIT: 'Submit',
    TEAM: 'Team',
    TEAM_CODE: 'Team Code',
    TEAM_NAME: 'Team Name',
    TOTAL_ADDRESSES: 'Total Addresses',
    TOTAL_REPS: 'Reps',
    UPDATE_REPS: 'Update Reps',
    VIEW_AREAS: 'View Areas',
    VIEW_MAP: 'View Map',
    VIEW_POLYGONS: 'View Polygons',
    VIEW_TEAMS: 'View Teams',
    WEEKS_SINCE_KNOCKED: 'Weeks since knocked',
};
export default dictionary;
